<template>
	<div class="grid">
		<Toast />
		<div class="col-12">
			<Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
		</div>

		<!-- Content -->
		<CreateInvoicePO
			v-if="currentUser"
			title="E-Invoice Summary"
			:currentUser="currentUser"
			:id="props.id"
		/>
	</div>
</template>

<script setup>
import { onMounted, ref, defineProps } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import AuthService from '../../../service/AuthService';
import CreateInvoicePO from '../../components/CreateInvoicePO.vue';

const router = useRouter();
const route = useRoute();

const props = defineProps(['id']);

const currentUser = ref(null);
const breadcrumbHome = ref({ icon: 'pi pi-home', to: '/dashboard' });
const breadcrumbItems = ref([
	{
		label: 'Detail Invoice',
		to: route.fullPath,
	},
]);

onMounted(async () => {
	const resAuth = await AuthService.whoAmi();
	currentUser.value = resAuth.data.data;

	// Check if user is not supplier nor finance nor admin
	if (
		currentUser.value.leveltenant !== 2 &&
		currentUser.value.leveltenant !== 1 &&
		currentUser.value.leveltenant !== 3 &&
		currentUser.value.userid !== 'dexaadmin'
	) {
		// Redirect to homepage if user is purchasing and not admin
		router.push('/dashboard');
		return;
	}
});
</script>
